import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  "data-testid": "list-reports-page",
  class: "page list-reports-page"
}
const _hoisted_2 = {
  ref: "filterPanel",
  class: "mt-10 page-filters-wrapper mb-6"
}
const _hoisted_3 = ["threshold"]
const _hoisted_4 = {
  key: 0,
  height: "100%"
}
const _hoisted_5 = { key: 4 }
const _hoisted_6 = {
  key: 7,
  class: "d-flex"
}
const _hoisted_7 = {
  key: 1,
  class: "d-flex align-center justify-center pt-5 mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_ReportPageCover = _resolveComponent("ReportPageCover")!
  const _component_ScoreDist = _resolveComponent("ScoreDist")!
  const _component_IrrAndIav = _resolveComponent("IrrAndIav")!
  const _component_EPS = _resolveComponent("EPS")!
  const _component_DataSetSegmentation = _resolveComponent("DataSetSegmentation")!
  const _component_SccAndIsy = _resolveComponent("SccAndIsy")!
  const _component_Outliers = _resolveComponent("Outliers")!
  const _component_ReportStaticText = _resolveComponent("ReportStaticText")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          threshold: _ctx.filterPanelPosition,
          class: _normalizeClass(["navbar page-filters-panel pos-relative justify-space-between", _ctx.scrolledAll ? 'vue-fixed-header--isFixed' : ''])
        }, [
          _createVNode(_component_v_layout, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                align: "end",
                justify: "space-between"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    class: "d-flex",
                    cols: "12",
                    sm: "9"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "3",
                            "align-self": "center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_label, null, {
                                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                  _createTextVNode("Provider", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_component_v_autocomplete, {
                                "model-value": _ctx.currentFilters.provider,
                                items: _ctx.providers,
                                "item-title": "name",
                                "item-value": "id",
                                label: "Provider",
                                variant: "solo",
                                disabled: _ctx.fetchingChartData,
                                "hide-details": "",
                                density: "compact",
                                class: "mt-2 filter-btn-active",
                                "single-line": "",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = 
                        (e) => {
                          _ctx.onProviderChange(e);
                        }
                      )
                              }, null, 8, ["model-value", "items", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    class: "d-flex justify-end my-2",
                    cols: "12",
                    sm: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        class: "filter-btn elevation-6 mt-0 mx-2",
                        ripple: false,
                        "data-testid": "ExportReportBtn",
                        variant: "text",
                        disabled: _ctx.fetchingChartData || _ctx.isSampleReport,
                        loading: _ctx.processingReport
                      }, {
                        default: _withCtx(() => [
                          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mx-2" }, "Export", -1)),
                          _createVNode(_component_v_icon, { small: "" }, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                              _createTextVNode("fas fa-file-pdf", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled", "loading"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 10, _hoisted_3)
      ], 512),
      _createElementVNode("div", null, [
        (!_ctx.fetchingChartData && !_ctx.fetchingSampleReport)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.currentFilters.coverPage)
                ? (_openBlock(), _createBlock(_component_ReportPageCover, {
                    key: 0,
                    data: _ctx.coverPageData,
                    chartData: _ctx.chartData,
                    isSampleReport: _ctx.isSampleReport
                  }, null, 8, ["data", "chartData", "isSampleReport"]))
                : _createCommentVNode("", true),
              (_ctx.currentFilters.awDist)
                ? (_openBlock(), _createBlock(_component_ScoreDist, {
                    key: 1,
                    data: _ctx.page2Data,
                    chartData: _ctx.chartData,
                    filters: _ctx.currentFilters,
                    isSampleReport: _ctx.isSampleReport
                  }, null, 8, ["data", "chartData", "filters", "isSampleReport"]))
                : _createCommentVNode("", true),
              (_ctx.currentFilters.iAsset || _ctx.currentFilters.Irr)
                ? (_openBlock(), _createBlock(_component_IrrAndIav, {
                    key: 2,
                    data: _ctx.page2Data,
                    chartData: _ctx.irrAndIavData,
                    filters: _ctx.currentFilters,
                    isSampleReport: _ctx.isSampleReport
                  }, null, 8, ["data", "chartData", "filters", "isSampleReport"]))
                : _createCommentVNode("", true),
              (_ctx.currentFilters.ePotSize)
                ? (_openBlock(), _createBlock(_component_EPS, {
                    key: 3,
                    data: _ctx.page2Data,
                    isSampleReport: _ctx.isSampleReport,
                    chartData: _ctx.ePotData,
                    filters: _ctx.currentFilters
                  }, null, 8, ["data", "isSampleReport", "chartData", "filters"]))
                : _createCommentVNode("", true),
              (_ctx.segmentData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.segmentData.numberGraphs, (val, key) => {
                      return (_openBlock(), _createBlock(_component_DataSetSegmentation, {
                        id: key,
                        key: key,
                        title: _ctx.capitalizeFirstLetterEveryWord(key),
                        type: "number",
                        chartData: val,
                        filters: _ctx.currentFilters,
                        isSampleReport: _ctx.isSampleReport
                      }, null, 8, ["id", "title", "chartData", "filters", "isSampleReport"]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.segmentData.stringGraphs, (val, key) => {
                      return (_openBlock(), _createBlock(_component_DataSetSegmentation, {
                        id: key,
                        key: key,
                        title: _ctx.capitalizeFirstLetterEveryWord(key),
                        type: "string",
                        chartData: val,
                        filters: _ctx.currentFilters,
                        isSampleReport: _ctx.isSampleReport
                      }, null, 8, ["id", "title", "chartData", "filters", "isSampleReport"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              ((_ctx.sccAndIsyData && _ctx.currentFilters.schemeSeg) || _ctx.currentFilters.yearSeg)
                ? (_openBlock(), _createBlock(_component_SccAndIsy, {
                    key: 5,
                    data: _ctx.page2Data,
                    chartData: _ctx.sccAndIsyData,
                    filters: _ctx.currentFilters,
                    isSampleReport: _ctx.isSampleReport
                  }, null, 8, ["data", "chartData", "filters", "isSampleReport"]))
                : _createCommentVNode("", true),
              (_ctx.currentFilters.outliers && _ctx.outliers && _ctx.outliers.length)
                ? (_openBlock(), _createBlock(_component_Outliers, {
                    key: 6,
                    data: _ctx.outlierPageData,
                    providerId: _ctx.currentFilters.provider,
                    isSampleReport: _ctx.isSampleReport
                  }, null, 8, ["data", "providerId", "isSampleReport"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ReportStaticText, { isSampleReport: _ctx.isSampleReport }, null, 8, ["isSampleReport"]),
              (_ctx.isSampleReport)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_v_btn, {
                      class: "filter-btn mx-auto elevation-6 my-8",
                      variant: "text",
                      onClick: _ctx.getVFMReport
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createElementVNode("span", { class: "call-btn-text" }, "Request my VFM report", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.fetchingChartData || _ctx.fetchingSampleReport)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "grey"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.requestVFMSuccessDialog,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestVFMSuccessDialog) = $event)),
        "onClick:outside": _cache[3] || (_cache[3] = ($event: any) => (_ctx.requestVFMSuccessDialog = false)),
        persistent: "",
        "max-width": "50vw"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, {
                class: "text-h6",
                style: {"word-break":"break-word"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.requestVFMmsg), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mx-auto",
                    color: "grey-darken-1",
                    variant: "text",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.requestVFMSuccessDialog = false))
                  }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("Ok", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}